import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import { Link, useNavigate, useLocation, useParams } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { StyledMember, StyledPanel, StyledItem } from '../stylesheets/styles';
import { API_URL } from '../common/constants';
import BgComponent from '../components/BgComponent';
import { Spinner } from 'react-bootstrap';
import AuthContext from '../contexts/AuthContext';
import ModalContext from '../contexts/ModalContext';

const NoticeDetail = (props) => {
  const { noticeId } = useParams(); // 獲取 noticeId 參數
  const [notice, setNotice] = useState(null);
  const { isAuth } = useContext(AuthContext);
  const { handleShow } = useContext(ModalContext);
  
  useEffect(() => {
    const fetchNotice = async () => {
      try {
        const token = localStorage.getItem('token');
        if (!token) {
          console.error('No token found');
          handleShow();
          return;
        }
  
        const response = await axios.get(`${API_URL}/api/notice/${noticeId}`, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });
        
        if (response.status === 401 || response.status === 500) {
          handleShow();
          return;
        }
  
        if (response.data.isSuccess) {
          setNotice(response.data.result);
        }
      } catch (error) {
        if (error.response && (error.response.status === 401 || error.response.status === 500)) {
          handleShow();
        } else {
          console.error('Error fetching notice:', error);
        }
      }
    };
  
    if (noticeId && isAuth) {
      fetchNotice();
    }
  }, [noticeId, isAuth]);

  
  
  return (
    <StyledMember className='register'>
      <div className='member-wrap'>
        <Container>
          <Row className="justify-content-md-center">
            <Col xl="7" lg="10" md="12">
              <StyledPanel className='content-panel'>
                { !notice
                  ? 
                    <div className='on-loading'>
                      <Spinner animation="border" role="status" variant="primary" >
                        <span className="visually-hidden">Loading...</span>
                      </Spinner>
                    </div>
                  :
                    <section className='section'>
                      <div className="hgroup mb-4">
                        <h1 className="subject mb-2">{notice.subject}</h1>
                        <p>{new Date(notice.publishDate).toLocaleDateString()}</p>
                      </div>
                      <div className='static-content ck-content' style={{ filter: "grayscale(1) brightness(0)" }}>
                        
                        {/* <Image src={notice.thumbnail ? notice.thumbnail : placeholder} /> */}
                        <div dangerouslySetInnerHTML={{ __html: notice.content }} />
                      </div>
                    </section>
                }
              </StyledPanel>
            </Col>
          </Row>
        </Container>
        <BgComponent/>
      </div>
    </StyledMember>
  );
};

export default NoticeDetail;
